import React, { useState, useRef } from "react";
import useSpeech from "./useSpeech";

// soundOption: 'none' | 'numbers' | 'numbers_phrases'
const PopOver = ({ number, onClose, drawDuration = 2000, reshow = false, soundOption = 'numbers_phrases' }) => {
  const [rollingNumber, setRollingNumber] = useState(number);
  const [isDrawing, setIsDrawing] = useState(false);
  const hasComplimented = useRef(false);

  const onFinish = (spokenText) => {
    // If sound is disabled, close immediately after animation
    if (soundOption === 'none') {
      setTimeout(onClose, 500);
      return;
    }
    // If the spoken text matches the number, close the popover
    if (spokenText === `${rollingNumber}`) {
      setTimeout(onClose, 500); // Delay closing after compliment
    } else {
      speak(`${rollingNumber}`); // Re-speak the number if needed
    }
  };

  const { speak } = useSpeech(onFinish);

  // Handle compliment logic based on sound option
  const sayComplimentaryText = () => {
    // If sound is disabled, just close after delay
    if (soundOption === 'none') {
      setTimeout(onClose, 1500);
      return;
    }

    // If only numbers, just speak the number
    if (soundOption === 'numbers') {
      if (!hasComplimented.current) {
        speak(`${number}`);
        hasComplimented.current = true;
      }
      return;
    }

    // Full mode: numbers + phrases
    const staticCompliments = {
      1: "Começou o jogo",
      5: "Aperte o cinto",
      6: "Meia Duzia",
      9: "Pingo no pé",
      10: "Craque de bola",
      11: "Um atrás do outro",
      12: "Na veia",
      13: "Deu azar",
      16: "O leão está solto",
      17: "O bicho que pula",
      18: "Já pode dirigir",
      22: "Dois patinhos na lagoa",
      23: "Descendente dele",
      31: "Preparem os fogos",
      33: "Idade de Cristo",
      38: "Justiça de Goiás",
      51: "Uma boa ideia",
      55: "Dois patinhos idosos",
      66: "Um tapa atrás da orelha",
      69: "Um indo, outro voltando",
      75: "Terminou o jogo",
    };

    const randomCompliments = [
      "Tá na hora do chá",
      "Aquecendo a cadeira",
      "Fechou a conta",
      "Olha a galera!",
      "Foguetinho subindo",
      "Chave do cofre",
      "Bingo chegando",
      "Avisa o pessoal",
      "Agora vai",
      "Vai pro jogo!",
      "Na reta final",
      "A vitória vem!",
      "Última chance",
      "Olha o prêmio",
      "Quem chegou primeiro?",
      "No pulo do gato",
      "Apressa que tá acabando",
      "Bingo em andamento",
      "A sorte está no ar",
      "Vem pra vitória",
      "Comemoração a caminho",
      "Virando o jogo",
      "Vai ser festa",
      "Na contagem regressiva",
      "Quase lá!",
      "Todo mundo de olho",
      "Quem tá na boa?",
      "Bingo. Tô brincando kkkk",
    ];

    const compliment =
      staticCompliments[number] || randomCompliments[Math.floor(Math.random() * randomCompliments.length)];

    if (!hasComplimented.current) {
      speak(compliment); // Speak the compliment once
      hasComplimented.current = true;
    }
  };

  const startRolling = () => {
    let counter = 0;
    setIsDrawing(true);

    const rollingInterval = setInterval(() => {
      setRollingNumber(Math.floor(Math.random() * 75) + 1);
      counter += 100;

      if (counter >= drawDuration) {
        clearInterval(rollingInterval);
        setRollingNumber(number);
        setIsDrawing(false);
        sayComplimentaryText();
      }
    }, 100);
  };

  // If not a reshow, start rolling on mount
  // eslint-disable-next-line
  React.useEffect(() => {
    if (!reshow) {
      startRolling();
    } else {
      sayComplimentaryText();
    }
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className="bg-white rounded-lg shadow-lg p-6 relative flex items-center justify-center"
        style={{ width: "80vw", height: "80vh" }}
      >
        <h2
          className="text-center font-bold"
          style={{ fontSize: isDrawing ? "40vmin" : "65vmin", lineHeight: "1", color: isDrawing ? "#777" : "#259646" }}
        >
          {rollingNumber}
        </h2>
        <button onClick={onClose} className="absolute top-2 right-2 text-red-500 hover:text-red-700">
          ✖
        </button>
      </div>
    </div>
  );
};

export default PopOver;